// src/providers/useGeoNavigate.js
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useGeo } from "./GeoContext";

function prefix(pathname, geo) {
  if (typeof pathname !== "string") return pathname;
  if (/^(https?:)?\/\//i.test(pathname)) return pathname; // external URL
  if (pathname.startsWith("#")) return pathname;          // hash only
  if (!pathname.startsWith("/")) return pathname;         // relative stays relative
  // absolute -> prefix with /{geo}
  return `/${geo}${pathname}`.replace(/\/{2,}/g, "/");
}

/** Works like useNavigate but auto-prefixes absolute paths with /{geo} */
export default function useGeoNavigate() {
  const nav = useNavigate();
  const { geo } = useGeo();

  return React.useCallback(
    (to, opts) => {
      // back/forward numbers pass through
      if (typeof to === "number") return nav(to);
      if (typeof to === "string") return nav(prefix(to, geo), opts);
      // "to" object: { pathname, search, hash, state }
      const next = { ...to, pathname: prefix(to?.pathname || "", geo) };
      return nav(next, opts);
    },
    [nav, geo]
  );
}
